import './styles/category-section.scss'
import {Checkbox} from "antd";
import React from "react";

interface Props {
    sectionName: string;
    list: any[];
    updateCheckedCategory: (categoryId:string | number) => void
    checkedCategories: any
}

function CategorySection({sectionName, list, updateCheckedCategory, checkedCategories}: Props) {
    if(list.length === 0) {
        return null;
    }

    return (
        <div className={'category-section'}>
            <div className={'category-section__header'}>
                { sectionName } ({list.length})
            </div>

            <div className={'category-section__list'}>
                {list.map((item) => (
                    <Checkbox
                        key={item.id}
                        value={item.id}
                        checked={checkedCategories.includes(item.id)}
                        onChange={() => {
                            const categoryId = item.id;
                            updateCheckedCategory(categoryId)
                        }}
                    >
                        {item.title}
                    </Checkbox>
                ))}
            </div>
        </div>
    )
}

export default CategorySection;